import { formatCurrency } from '#/lib/currency';
import isMoney from '@jucy-nakuru/common/lib/isMoney';
import { ProductType } from '@jucy/rentals-api-client/rentals-api/models/ProductType';

export const formatUnitTitle = ({
    price,
    quantity = 1,
    type,
    rentalDays = 1,
}: {
    price: Partial<{ currencyCode: string; value: number }>;
    allowMultiple?: boolean;
    quantity?: number;
    type: ProductType | string;
    rentalDays?: number;
}) => {
    const result = {
        titlePrefix: '',
        unitTitle: '',
    };
    if (quantity > 0) {
        result.titlePrefix = `${quantity} x `;
    }
    if (type == ProductType.Percentage || !isMoney(price)) {
        return result;
    }

    const unit = type === ProductType.Daily ? 'day' : 'each';
    result.unitTitle = `${formatCurrency(price.value, price.currencyCode)} / ${unit}`;
    if (type === 'Daily') {
        const days = `day${rentalDays !== 1 ? 's' : ''}`;
        result.unitTitle += ` x ${rentalDays} ${days}`;
    }
    return result;
};
